const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/")({
  loader: async ({
    params
  }) => {
    const {
      tluxCaseId
    } = params;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].sikring.defaults.$get({
      param: {
        tluxCaseId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch sikring template");
    }
    return {
      sikring: await res.json()
    };
  },
  head: () => {
    return {
      meta: [{
        title: "Opprett sikring | Alice & Bob"
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});